// Product image slider
$(document).ready(function(){
	$('body').find(".ws_list > ul a.product-fancybox ").click(function(a){
			var allImages	=	$(this).parents('ul').find('li a');
			var slides		=	[];
			var currIndex	=	$(this).parent().index();
			for(var i = 0; i < allImages.length; i++)
			{
				slides.push({
					href : $(allImages[i]).attr('href'),
					title : $(allImages[i]).attr('title'),
					type: $(allImages[i]).attr('type')
				 });
			}
			
			$.fancybox.open(
			 	slides,
				{
					autoScale : true,
					maxWidth : 900,
					helpers : {
			    		title : {
			    			type : 'inside',
							position: 'top'
			    		}
			    	},
					padding      : [10, 30, 10, 30],
					index : currIndex,
					afterLoad : function() {
						this.outer = $(this.outer).after('<div class="fancybox-index">'+(this.index + 1)+'/'+this.group.length+'</div>');
					}
			    });
			return false;
		});
});
